import { render, staticRenderFns } from "./Situazione.vue?vue&type=template&id=d945d07e&scoped=true"
import script from "./Situazione.vue?vue&type=script&lang=js"
export * from "./Situazione.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d945d07e",
  null
  
)

export default component.exports